import CollaborationArrow from '@/components/@icons/CollaborationArrow.vue'
import CollaborationRegisterArrow from '@/components/@icons/CollaborationRegisterArrow.vue'
import CollaborationForm from './components/form/index.vue'
import CollaborationPhone from './components/phone/index.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { parseListItems, parseListItemsText } from '@/utils/parseListHtml'
import dynamicsHead from "@/mixins/dynamics-head";

export default {
  name: 'CollaborationPage',
  data() {
    return {
      windowSize: window.innerWidth,
    }
  },
  components: {
    CollaborationArrow,
    CollaborationRegisterArrow,
    CollaborationForm,
    CollaborationPhone,
  },
  methods: {
    parseListItems: parseListItems,
    parseListItemsText: parseListItemsText,
    ...mapActions({
      fetchPage: 'pages/GET_PAGE',
    }),
    ...mapMutations({
      showGlobalLoader: 'system/SHOW_GLOBAL_LOADER',
    }),
    getPageContent(itemId) {
      try {
        if (!this.page || !this.page?.pageContents || !this.page?.pageContents.data || !this.page?.pageContents.data.length) return
        return this.page?.pageContents.data.find(({ id }) => id === itemId)
      } catch (error) {
      }
    },
    scrollToForm() {
      const formElement = this.$refs.formContainer
      if (formElement) {
        const yOffset = -64
        const y = formElement.getBoundingClientRect().top + window.pageYOffset + yOffset
        window.scrollTo({ top: y, behavior: 'smooth' })
      }
    },
  },
  computed: {
    ...mapGetters({
      page: 'pages/page',
      globalLoader: 'system/globalLoader',
    }),
    getOfferContent() {
      return this.page?.pageOffer.data
    },
    getReasonContent() {
      return this.page?.pageReasons.data
    },
  },
  mixins: [dynamicsHead],
  async created() {
    console.log('collaboration', this.$route)
    this.showGlobalLoader(true)
    await this.fetchPage('cooperation')
    this.setPageMetaInfo(this.page);
    this.showGlobalLoader(false)
  },
}
